// Deployments — challenge runs (Antimatter Dimensions Infinity/Eternity
// challenges; Leaf Blower Revolution & Revolution Idle challenges). Each is an
// opt-in restricted enlistment with a rank target; completing it grants a
// permanent stacking reward. Solo by construction.
export const CHALLENGES = [
  {
    id: 'austerity',
    name: 'Austerity Posting',
    detail: 'No upgrades may be adopted. Make do with what you are issued.',
    target: 6, // reach 3SG
    reward: 'Permanent +15% base output.',
    rewardMult: 1.15,
    blocks: { upgrades: true },
  },
  {
    id: 'skeleton',
    name: 'Skeleton Crew',
    detail: 'Only tiers 1–3 exist. Hold the line with a light formation.',
    target: 6,
    reward: 'Tiers 1–3 cost 20% less, always.',
    rewardMult: 1,
    blocks: { tierAbove: 3 },
  },
  {
    id: 'blackout',
    name: 'Signals Blackout',
    detail: 'Commons multipliers are disabled. No Supply lift, no Readiness.',
    target: 7,
    reward: 'Commons accrue 50% faster, always.',
    rewardMult: 1,
    blocks: { commons: true },
  },
  {
    id: 'forced-march',
    name: 'Forced March',
    detail: 'Unit costs scale 25% steeper. Every purchase is a decision.',
    target: 7,
    reward: 'Permanent +25% base output.',
    rewardMult: 1.25,
    blocks: { costGrowth: 1.25 },
  },
];

export function challengeFor(id) { return CHALLENGES.find((challenge) => challenge.id === id); }

// Total output reward multiplier from all completed challenges.
export function challengeRewardMult(done = []) {
  let mult = 1;
  for (const challenge of CHALLENGES) {
    if (challenge.rewardMult && done.includes(challenge.id)) mult *= challenge.rewardMult;
  }
  return mult;
}
